module.exports = __webpack_public_path__ + "img/brand.d2ee8902.png";